export { default } from './EditJsonBlock';

export const displayName = 'JSON';
